import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { brand } from '../brand';
import Ituka from './Ituka';

/**
 * The picture beside the name in a page's header.
 *
 * On an employer's own address (Interview as a Service) that is the employer's logo, kept to the header's height; with no logo yet, or
 * one that will not load, the first letter of its name in its color, because the product's own mascot would say whose page it is. Anywhere
 * else it is the product's mascot, as it always was.
 */
const BrandMark = ({ size = 36, sx, label, logoUrl = brand.logoUrl, name = brand.name }) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [logoUrl]);

  if (!brand.employer) return <Ituka size={size} still sx={sx} {...(label ? { label } : {})} />;

  if (logoUrl && !failed) {
    return (
      <Box
        component="img"
        src={logoUrl}
        alt={`${name} logo`}
        onError={() => setFailed(true)}
        sx={{ display: 'block', height: size, maxWidth: size * 4, width: 'auto', objectFit: 'contain', flexShrink: 0, ...sx }}
      />
    );
  }

  return (
    <Box
      aria-hidden
      sx={{
        width: size, height: size, flexShrink: 0, borderRadius: '50%', display: 'grid', placeItems: 'center',
        bgcolor: 'primary.main', color: 'primary.contrastText', fontWeight: 700, fontSize: size * 0.5, lineHeight: 1, ...sx,
      }}
    >
      {String(name).trim().charAt(0).toUpperCase()}
    </Box>
  );
};

export default BrandMark;
